import i18n from '@/plugins/i18n';

export const getMMNavTabs = () => [
  {
    name: i18n.global.t('dashboard'),
    path: 'mblDashboard',
    fullPath: '/mobile/mblDashboard',
  },
  {
    name: i18n.global.t('kpis'),
    path: 'kpis',
    fullPath: '/mobile/kpis',
    kpisTab: [
      {
        tabName: i18n.global.t('usage-tab'),
        routerName: 'usage',
      },
      {
        tabName: i18n.global.t('crashes'),
        routerName: 'crashes',
      },
      {
        tabName: i18n.global.t('performance'),
        routerName: 'performance',
      },
    ],
  },
];

const mobile = {
  key: 'mobile',
  name: i18n.global.t('mobileMonitoring'),
  icon: 'mobile',
  navTabs: getMMNavTabs(),
};
export default mobile;
